import { z } from "zod";

const agentUsageRangeFields = z.object({
    start: z.string().date(),
    end: z.string().date().optional(),
});

type AgentUsageRangeFields = z.infer<typeof agentUsageRangeFields>;

const isEndOnOrAfterStart = ({ start, end }: AgentUsageRangeFields) =>
    end === undefined || start <= end;

const END_BEFORE_START_ISSUE = {
    path: ["end"],
    message: "End date must be on or after start date",
};

export const agentUsageQuerySchema = agentUsageRangeFields.refine(
    isEndOnOrAfterStart,
    END_BEFORE_START_ISSUE,
);
export type AgentUsageQuery = z.infer<typeof agentUsageQuerySchema>;

export const agentUsageRangeSchema = z.object({
    start: z.string().date(),
    end: z.string().date(),
});
export type AgentUsageRange = z.infer<typeof agentUsageRangeSchema>;

export const agentUsageClientSchema = z.object({
    workspaceId: z.string().uuid(),
    freeTokens: z.number().int().nonnegative(),
    paidTokens: z.number().int().nonnegative(),
    shareOfUsage: z.number().min(0).max(1),
    tasksCount: z.number().int().nonnegative(),
    lastActivityAt: z.string().datetime().nullable(),
});
export type AgentUsageClient = z.infer<typeof agentUsageClientSchema>;

export const agentUsageResponseSchema = z.object({
    clients: z.array(agentUsageClientSchema),
    totalTokens: z.number().int().nonnegative(),
    range: agentUsageRangeSchema,
});
export type AgentUsageResponse = z.infer<typeof agentUsageResponseSchema>;

export const agentUsageMonthSchema = z.object({
    month: z.string().date(),
    freeTokens: z.number().int().nonnegative(),
    paidTokens: z.number().int().nonnegative(),
});
export type AgentUsageMonth = z.infer<typeof agentUsageMonthSchema>;

export const agentUsageMonthlyResponseSchema = z.object({
    months: z.array(agentUsageMonthSchema),
    range: agentUsageRangeSchema,
});
export type AgentUsageMonthlyResponse = z.infer<
    typeof agentUsageMonthlyResponseSchema
>;
